<template>
  <v-form ref="saleEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'sale-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{ this.id ? 'Редактирование акции' : 'Создание акции' }}</h1>
        <v-tabs v-model="tab" class="pt-6 pb-6">
          <v-tab>Описание</v-tab>
          <v-tab>Блоки</v-tab>
          <v-tab>Блюда</v-tab>
          <v-tab>Изображение</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item :eager="true">
            <v-col cols="12" sm="5" md="4" xl="3" class="pl-0 pr-0">
              <sale-form v-if="!id || (id && sale.id)" v-model="sale" :loading="loading" :rules="rules"
                         :tab-lang="tabLang"></sale-form>
              <v-btn v-if="id" @click="update">Сохранить</v-btn>
              <v-btn v-else @click="create">Создать</v-btn>
            </v-col>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col cols="12" sm="12" md="6" xl="6">
                <div v-if="sale.blocks" v-for="(block, index) in sale.blocks" >
                  <div class="text"><span>Блок {{ index + 1}}</span><div class="remove" @click="submitDialog = true; submitItem = block"><v-icon>mdi-close</v-icon></div></div>
                  <div class="block" :class="{reverse: block.is_reverse}">
                    <div class="left">
                      <v-img :src="block.image_url" width="246" height="195" class="mb-8">
                        <template v-slot:placeholder>
                          <div class="image-placeholder"></div>
                        </template>
                      </v-img>
                      <v-file-input label="Картинка"
                                    prepend-icon=""
                                    class="cursor-pointer"
                                    outlined
                                    @change="appendImage(block)"
                                    placeholder="1902х1508.jpg"
                                    append-icon="mdi-attachment"
                                    hide-details
                                    v-model="block.image_file">
                      </v-file-input>
                    </div>
                    <div class="reverse" @click="block.is_reverse = !block.is_reverse"><v-icon large>mdi-swap-horizontal</v-icon></div>
                    <div class="right">
                      <v-tabs v-model="block.tab" class="pb-2">
                        <v-tab>RU</v-tab>
                        <v-tab>UA</v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="block.tab">
                        <v-tab-item :eager="true">
                          <v-text-field
                              v-model="block.title"
                              label="Заголовок"
                              outlined
                          ></v-text-field>
                          <v-textarea
                              v-model="block.description"
                              label="Описание"
                              outlined
                              hide-details
                          ></v-textarea>

                        </v-tab-item>
                        <v-tab-item :eager="true">
                          <v-text-field
                              v-model="block.title_ua"
                              label="Заголовок"
                              outlined
                          ></v-text-field>
                          <v-textarea
                              v-model="block.description_ua"
                              label="Описание"
                              outlined
                              hide-details
                          ></v-textarea>
                        </v-tab-item>
                      </v-tabs-items>
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <v-btn outlined @click="addBlock">Добавить блок</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <sale-products-modal v-model="sale" :products-categories="productCategories"
                                 v-if="sale.id && productCategories.length > 0"></sale-products-modal>
            <v-data-table v-if="sale.id"
                          no-data-text="Нет блюд"
                          no-results-text="По заданному запросу ничего не найдено"
                          :headers="headers"
                          :items="sale.products"
                          :options.sync="options"
                          :header-props="{sortIcon: 'icon-custom-arrow'}"
                          :footer-props="footerProps"
                          :loading="loading"
                          :item-class="getItemClass"
                          :items-per-page="30"
                          loading-text="Загрузка блюд... Подождите пожалуйста"
            >
              <template v-slot:item.price="{ item, index }">
                {{ item.price }} UAH
              </template>
              <template v-slot:item.tag="{ item, index }">
                    <span v-for="tag in item.tags">{{ tag.name }}{{
                        tag == item.tags[item.tags.length - 1] ? '' : ', '
                      }} </span>
              </template>
              <template v-slot:item.category.name="{ item }">
                <template v-if="item.category">
                  {{ item.category.name }} {{ item.category.parent ? '- ' + item.category.parent : '' }}
                </template>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item :eager="true">
            <div class="mb-8">
              <v-img :src="previewImage(true, bannerImage)" width="516px" height="162px">
                <template v-slot:placeholder>
                  <div class="image-placeholder"></div>
                </template>
              </v-img>
            </div>
            <div style="width: 246px">
              <v-file-input label="Баннер"
                            prepend-icon=""
                            outlined
                            accept="image/jpeg,image/png"
                            class="cursor-pointer"
                            v-model="bannerImage">
              </v-file-input>
            </div>
            <div class="mb-8">
              <v-img :src="previewImage(false, comicsImage)" width="246px" height="195px">
                <template v-slot:placeholder>
                  <div class="image-placeholder"></div>
                </template>
              </v-img>
            </div>
            <div style="width: 246px">
              <v-file-input label="Комикс"
                            prepend-icon=""
                            outlined
                            accept="image/jpeg,image/png"
                            class="cursor-pointer"
                            v-model="comicsImage">
              </v-file-input>
            </div>
            <v-btn :loading="loadingButton" v-if="id" @click="updateImages">Сохранить</v-btn>
          </v-tab-item>
        </v-tabs-items>
      </v-col>

    </v-row>
    <v-dialog
        v-model="submitDialog"
        max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
              v-if="submitItem == null"
              @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
              v-else
              @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
              outlined
              @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        right
        top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-form>
</template>

<script>
// @ is an alias to /src
import SaleService from './../../api/SaleService'
import SaleForm from './Partial/Form'
import SaleProductsModal from './../../components/SaleProductsModal'
import ProductService from "../../api/ProductService";

export default {
  name: 'SaleEdit',
  props: {
    id: {
      default: null,
    },
  },
  components: {SaleProductsModal, SaleForm},
  data: () => ({
    snackbar: false,
    timeout: 2000,
    snackbarText: '',
    snackbarColor: '',
    rules: {
      required: value => !!value || 'Нужно заполнить',
      requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
    },
    valid: true,
    selected: [],
    options: {},
    footerProps: {
      itemsPerPageText: 'Блюд на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [30]
    },
    tab: null,
    tabLang: 0,
    bannerImage: null,
    comicsImage: null,
    headers: [
      {
        text: 'Блюдо',
        value: 'name',
      },
      {text: 'Категория', value: 'category.name'},
      {
        text: 'Теги',
        value: 'tag',
      },
      {
        text: 'Цена',
        value: 'price',
      },
      {
        text: 'Кол-во заказов',
        value: 'order_items_count',
      },
    ],
    sale: {
      productRelations: [],
      name: '',
      name_ua: '',
      description: '',
      description_ua: '',
      condition: '',
      condition_ua: '',
      button_text: '',
      button_text_ua: '',
      button_url: '',
      date_from: '',
      date_to: '',
      time_from: '',
      time_to: '',
      type: 'all',
      enabled: false,
      discount: '',
    },
    submitDialog: false,
    submitItem: null,
    loading: true,
    loadingButton: false,
    productCategories: []
  }),
  mounted() {
    if (this.id) {
      SaleService.get(this.id)
          .then(response => {
            this.sale = response.data;

            if(this.sale.banner_image){
              this.bannerImage = this.sale.banner_image;
              this.bannerImage.name = this.sale.banner_image.file
            }

            if(this.sale.comics_image){
              this.comicsImage = this.sale.comics_image;
              this.comicsImage.name = this.sale.comics_image.file
            }

            this.loading = false
          });

    }

    ProductService.listByCategory().then(response => {
      this.productCategories = response.data
    })
  },
  watch: {},
  methods: {
    appendImage(block){
      block.image_url = URL.createObjectURL(block.image_file)
    },
    submitDelete(block){
      this.sale.blocks.splice(this.sale.blocks.indexOf(block) , 1)
    },
    addBlock(){
      if(this.sale.blocks === undefined || !this.sale.blocks){
        this.sale.blocks = []
      }

      this.sale.blocks.push(Object.assign({}, this.block))
    },
    validate() {
      this.$refs.saleEditForm.validate()

      if (this.sale.name == '' && this.sale.name_ua != '') {
        this.tabLang = 0;
      }
      if (this.sale.name != '' && this.sale.name_ua == '') {
        this.tabLang = 1;
      }

      // if (this.sale.description == '' && this.sale.description_ua != '') {
      //   this.tabLang = 0;
      // }
      // if (this.sale.description != '' && this.sale.description_ua == '') {
      //   this.tabLang = 1;
      // }
      //
      // if (this.sale.condition == '' && this.sale.condition_ua != '') {
      //   this.tabLang = 0;
      // }
      // if (this.sale.condition != '' && this.sale.condition_ua == '') {
      //   this.tabLang = 1;
      // }
    },
    previewImage(isBanner, image) {
      if (isBanner) {
        if (this.bannerImage && this.bannerImage.url) {
          return this.bannerImage.url
        }
      } else {
        if (this.comicsImage && this.comicsImage.url) {
          return this.comicsImage.url
        }
      }
      if (image) {
        return URL.createObjectURL(image)
      }

    },
    getItemClass(item) {
      if (item.hide == 1) {
        return 'hidden-product'
      }
    },
    updateImages(){
      this.loadingButton = true;
      var formData = this.getDataImage();

      SaleService.update(this.sale.id, formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Акция успешно обновлена';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении акции';
        this.snackbarColor = 'error';
      }).finally(() => {this.loadingButton = false; this.loading = false;})
    },
    getDataImage(){
      let formData = new FormData();
      formData.append('is_images', '1');
      if (this.id) {
        if (this.bannerImage && !this.bannerImage.url) {
          formData.append('bannerImage', this.bannerImage);
        }
        if (this.comicsImage && !this.comicsImage.url) {
          formData.append('comicsImage', this.comicsImage);
        }

      }

      return formData
    },
    update() {
      this.validate()
      if (!this.valid) {
        return false
      }
      this.loadingButton = true;
      let formData = this.getData();

      SaleService.update(this.sale.id, formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Акция успешно обновлена';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении акции';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
        this.loading = false;
      })
    },
    create() {
      this.validate()
      if (!this.valid) {
        return false
      }
      this.loadingButton = true;
      var formData = this.getData();

      SaleService.create(formData).then(response => {
        this.snackbar = true;
        this.sale = response.data
        this.$router.push({name: 'sale-edit', params: {id: response.data.id}})
        this.snackbarText = 'Акция успешно создана';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при создании акции';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
        this.loading = false;
      })
    },
    getData() {
      let formData = new FormData();

      formData.append('name', this.sale.name);
      formData.append('date_from', this.sale.date_from);
      formData.append('date_to', this.sale.date_to);
      formData.append('time_from', this.sale.time_from);
      formData.append('time_to', this.sale.time_to);
      formData.append('name_ua', this.sale.name_ua);
      formData.append('description', this.sale.description);
      formData.append('description_ua', this.sale.description_ua);
      formData.append('condition', this.sale.condition);
      formData.append('condition_ua', this.sale.condition_ua);
      formData.append('button_text', this.sale.button_text);
      formData.append('button_text_ua', this.sale.button_text_ua);
      formData.append('button_url', this.sale.button_url);
      formData.append('discount', this.sale.discount);
      formData.append('type', this.sale.type);

      formData.append('enabled', this.sale.enabled ? 1 : 0);

      this.sale.blocks.forEach(function (item, index) {
        formData.append(`blocks[${index}][title]`, item.title);
        formData.append(`blocks[${index}][title_ua]`, item.title_ua);
        formData.append(`blocks[${index}][description]`, item.description);
        formData.append(`blocks[${index}][description_ua]`, item.description_ua);
        formData.append(`blocks[${index}][image]`, item.image);
        formData.append(`blocks[${index}][image_url]`, item.image_url);
        formData.append(`blocks[${index}][is_reverse]`, item.is_reverse);

        if(item.image_file && !item.image_file.url) {
          formData.append(`blocks[${index}][image_file]`, item.image_file);
        }
      })

      return formData;
    }
  },
}
</script>

<style lang="scss" scoped>
.image-placeholder{
  width: 100%;
  height: 100%;
  background-color: #F3F7FC;
  border-radius: 4px;
}
</style>

<style scoped lang="scss">
.text{
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #5D6670;
  display: flex;
  justify-content: space-between;
  .remove{
    &:hover{
      .v-icon{
        color: red;
        cursor: pointer;
      }
    }
  }
}
.block{
  display: grid;
  grid-template-columns: 31% 6% 48%;
  grid-column-gap: 7.5%;
  border-bottom: 1px solid #E0E8F0;
  padding-bottom: 32px;
  margin-bottom: 32px;



  .reverse{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  &.reverse{
    grid-template-columns: 48% 6% 31%;
    .left{
      order: 3;
    }
    .right{
      order: 1;
    }
    .reverse{
      order: 2;
    }
  }
}
.image-placeholder {
  width: 100%;
  height: 100%;
  background-color: #F3F7FC;
  border-radius: 4px;
}

.contact-images .v-image {
  max-height: 374px;
}

.mobile {
  width: 300px;
  height: 300px;
  margin-bottom: 24px;
}

.contact {
  position: relative;

  &:before {
    content: "";
    padding-top: 100%;
    display: block;
  }

  .content {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #F8FBFF;
    border-right-style: 3px;

    .img {
      height: 3.541vw;
      margin-top: .83vw;
    }

    .name {
      margin-top: .72vw;
      text-align: center;
      color: #8C959D;
    }
  }
}
</style>